import { render, staticRenderFns } from "./OrgCountByTypeAndOrgAdminComponent.vue?vue&type=template&id=5f1deca4&scoped=true&"
import script from "./OrgCountByTypeAndOrgAdminComponent.vue?vue&type=script&lang=js&"
export * from "./OrgCountByTypeAndOrgAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1deca4",
  null
  
)

export default component.exports